export default __webpack_public_path__ + "static/media/finance001.529fe2e0.png";